import { MouseEvent, useEffect, useRef, useState } from 'react';

import { language } from './language';
import { TUseCopyButtonParams } from './types';

export const useCopyButton = ({
  text,
  duration = 1500,
  onCopied,
}: TUseCopyButtonParams) => {
  const [copied, setCopied] = useState(false);
  const [open, setOpen] = useState(false);
  const timerRef = useRef<number | null>(null);

  const clearTimer = () => {
    if (timerRef.current) {
      window.clearTimeout(timerRef.current);
      timerRef.current = null;
    }
  };

  const handleCopy = async (e: MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    if (!text) return;

    try {
      await navigator.clipboard.writeText(text);

      setCopied(true);
      setOpen(true);
      onCopied?.();

      clearTimer();
      timerRef.current = window.setTimeout(() => {
        setCopied(false);
        setOpen(false);
      }, duration);
    } catch (error) {
      console.error(language.copyFailed, error);
    }
  };

  const handleOpenChange = (next: boolean) => {
    setOpen(next);
    if (!next) setCopied(false);
  };

  useEffect(() => {
    return () => {
      clearTimer();
    };
  }, []);

  return {
    state: { copied, open },
    handlers: {
      handleCopy,
      handleOpenChange,
      setOpen,
    },
  };
};
